module.exports = __webpack_public_path__ + "static/media/world.0db0f1ea.svg";